<mat-toolbar class="header" color="primary" style="display: flex;flex-flow:row;justify-content:space-between;">
  <h1 routerLink="./" style="cursor:pointer;" title="Dashboard">Health Data Tracker</h1>
  <div style="display: flex;flex-flow:row;align-items:center;">
    <span routerLink="./about" style="cursor:pointer;">About</span>
    <mat-icon (click)="goToSyncSetup()" style="cursor:pointer;margin-left:10px;">sync</mat-icon>
    <mat-icon (click)="download()" style="cursor:pointer;margin-left:10px;">get_app</mat-icon>
    <mat-icon routerLink="./import" style="cursor:pointer;margin-left:10px;" title="import from another device">call_merge</mat-icon>
  </div>
</mat-toolbar>
<main class="body">
  <message-toast></message-toast>
  <mat-card id="content">
  <router-outlet></router-outlet>
  </mat-card>
</main>